<template>
  <ResearchGalleryPage
    page-title="办公地点变更"
    section-label="建制沿革"
    :section-route="sectionRoute"
    :top-strip-image="topStripImage"
    :hero-background-image="heroBackgroundImage"
    :groups="groups"
  />
</template>

<script>
import ResearchGalleryPage from '@/components/ResearchGalleryPage.vue';

export default {
  name: 'LanhuBangongdidianbiangeng',
  components: {
    ResearchGalleryPage
  },
  data() {
    return {
      sectionRoute: {
        path: '/lanhu_jigouyulishi',
        query: { item: 'evolution-history', subitem: 'office-location-change' }
      },
      topStripImage: require('@/views/lanhu_jigouyulishi/assets/img/SketchPnge6526ecb2fcab0802b546f04824fe8f83db80e06fef6b8cf3b08d187c494f182.png'),
      heroBackgroundImage: require('@/views/lanhu_zhengwenyexueshuchengguo/assets/img/173301bb9c6d42d7ae3028c182487260_mergeImage.png'),
      groups: [
        {
          title: '办公地点变更',
          kicker: '1984-2017',
          columns: 3,
          description:
            '新闻与传播研究所的所址最初在人民日报大院 15 号楼、9 号楼，2009 年部分搬至东城区先晓胡同中国版本图书馆 3 层、4 层，2010 年整体进入光华路泰达时代中心 10 层，2016 年 2 月搬迁到潘家园东里 9 号国家方志馆 2 层至今。',
          items: [
            {
              src: require('./assets/html/office-1984-renminribao.jpg'),
              caption: '1984 年，中国报刊史研究室科研人员在人民日报社 9 号楼前合影'
            },
            {
              src: require('./assets/html/office-1988-9-building.jpg'),
              caption: '1988 年，安岗同参加“安岗新闻工作五十年座谈会”的新闻研究所的同事在人民日报社 9 号楼前合影留念'
            },
            {
              src: require('./assets/html/office-2009-xianxiao.jpg'),
              caption: '2009 年，新闻与传播研究所在先晓胡同 10 号中国版本图书馆三层、四层办公'
            },
            {
              src: require('./assets/html/office-2010-taida.jpg'),
              caption: '2010 年至 2016 年，新闻与传播研究所在光华路 15 号院泰达时代中心 1 号楼 10 层办公'
            },
            {
              src: require('./assets/html/office-2016-leave-taida.jpg'),
              caption: '2016 年 2 月，搬离泰达时代中心 1 号楼 10 层，所领导与办公室人员在会议室留影'
            },
            {
              src: require('./assets/html/office-2017-fangzhiguan.jpg'),
              caption:
                '2016 年搬迁至潘家园东里 9 号国家方志馆。图为 2017 年 3 月，所内部分同事在国家方志馆二层会议室参加三八妇女节插花活动',
              wide: true
            }
          ]
        }
      ]
    };
  }
};
</script>
